import { render, staticRenderFns } from "./Emailed.vue?vue&type=template&id=2d186bbd&"
import script from "./Emailed.vue?vue&type=script&lang=js&"
export * from "./Emailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports